export default __webpack_public_path__ + "static/media/small-logo.316fe763.png";